import { createRouteRef } from '@backstage/frontend-plugin-api';

export const rootRouteRef = createRouteRef();
export const overviewRouteRef = createRouteRef();
export const languagesAndFrameworksRouteRef = createRouteRef();
export const toolsRouteRef = createRouteRef();
export const platformsRouteRef = createRouteRef();
